// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Agent Batch Upload'"></sub-header>

  <h2 class="section-header">Please confirm the following:</h2>

  <form name="\$ctrl.form">
    <table class="table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Branch</td>
        <td>
          <select
            required
            ng-model="\$ctrl.branchId"
            ng-options="branch.id as branch.name for branch in \$ctrl.branches">
          </select>
        </td>
      </tr>

      <tr>
        <td></td>
        <td>Account</td>
        <td>
          <select
            ng-model="\$ctrl.accountId"
            ng-options="type.id as type.productDefinition.productName | prettyEnum for type in \$ctrl.filterByBranchAvailability(\$ctrl.accountTypes)"
            ng-required="true">
          </select>
        </td>
      </tr>

      <tr>
        <td></td>
        <td>Other options</td>
        <td>
          <div ng-if="\$ctrl.smsSupported">
            <label for="sms">
              <input id="sms" type="checkbox" ng-model="\$ctrl.sendPasswordUsingSms"/>
              Send password using SMS
            </label>
          </div>

          <div>
            <label for="autogen">
              <input id="autogen" type="checkbox" ng-model="\$ctrl.appendSequence"/>
              Autogenerate username
            </label>
          </div>
        </td>
      </tr>

      <tr ng-if="\$ctrl.appendSequence">
        <td></td>
        <td>Username prefix</td>
        <td>
          <div class="alert">
            Dash (-) will be appended to the usernames automatically.<br/>
            Usernames on the CSV file must be blank.
          </div>
          <div>
            <input type="text" ng-model="\$ctrl.usernamePrefix" ng-required="\$ctrl.appendSequence"/>
          </div>
        </td>
      </tr>

      <tr>
        <td></td>
        <td>CSV File
        </td>
        <td>
          <file-id-upload
            ng-model="\$ctrl.fileId"
            single-file="true"
            max-files="1"
            show-file-name="true"
            enable-webcam="false"
            validate='{pattern: "*.csv"}'
            show-remarks="false"
            required>
          </file-id-upload>
        </td>
      </tr>

      </tbody>
    </table>

    <div class="buttons">
      <button class="btn btn-info" ng-click="\$ctrl.downloadSampleFile()">Download example</button>
      <button class="btn btn-success" ng-click="\$ctrl.submit()" ng-disabled="\$ctrl.form.\$invalid">Submit</button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/batch-upload/agent-batch-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;